import Vue from 'vue';
import Router from 'vue-router';
import Login from './components/Views/Login.vue';
import Dashboard from './components/Views/Dashboard.vue';
import Header from './components/Views/Header.vue';
import CoursePanel from './components/Views/Course/CoursePanel.vue'
import Modules from './components/Views/Modules.vue'
import Lesson from './components/Views/Lesson/Lesson.vue'
import UserList from './components/Views/UserList.vue'
import UserPage from './components/Views/UserPage.vue'
import CourseList from './components/Views/Course/CourseList.vue'
import CoursePage from './components/Views/Course/CoursePage.vue'
import ProductList from './components/Views/Product/ProductList.vue'
import ProductPage from './components/Views/Product/ProductPage.vue'
import QuestionList from './components/Views/Questions/QuestionList'
import { store } from './store';
import QuizList from './components/Views/Quiz/QuizList'
import ReportsPage from './components/Views/Reports/ReportsPage'
import TopicList from './components/Views/Forum/TopicList'
import ViewTopic from './components/Views/Forum/ViewTopic'
import LiveLesson from './components/Views/Live/LiveLesson'
import AnnotationsList from './components/Views/Annotations/AnnotationsList'
import AlertList from './components/Views/Alert/AlertList'
import StudentList from './components/Views/Grade/StudentList'
import CalendarList from './components/Views/Calendar/CalendarList'

Vue.use(Router);

let router = new Router({
  mode: 'history',
  linkActiveClass: "active",
  linkExactActiveClass: 'active',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login,
    },
    {
      path: '/home',
      name: 'Dashboard',
      component: Header,
      children: [
        {
          path: 'dashboard',
          component: Dashboard
        },
        {
          path: 'coursepanel',
          component: CoursePanel
        },
        {
          path: 'classes',
          component: Modules
        },
        {
          path: 'lesson',
          name: 'lesson',
          component: Lesson
        },
        {
          path: 'users',
          name: 'users',
          component: UserList
        }, {
          path: 'edituser',
          name: 'edituser',
          component: UserPage,
          props: true
        },
        {
          path: 'courses',
          name: 'courses',
          component: CourseList
        }, {
          path: 'editcourse',
          name: 'editcourse',
          component: CoursePage,
          props: true
        },
        {
          path: 'products',
          name: 'products',
          component: ProductList
        },
        {
          path: 'editproduct',
          name: 'editproduct',
          component: ProductPage,
          props: true
        },
        {
          path: 'questions',
          name: 'questions',
          component: QuestionList
        },
        {
          path: 'quizlist',
          name: 'quizlist',
          component: QuizList
        },
        {
          path: 'reports',
          name: 'reports',
          component: ReportsPage
        },
        {
          path: 'topics',
          name: 'topics',
          component: TopicList
        },
        {
          path: 'viewtopic',
          name: 'viewtopic',
          component: ViewTopic
        },
        {
          path: 'live',
          name: 'live',
          component: LiveLesson
        },
        {
          path: 'annotations',
          name: 'annotations',
          component: AnnotationsList
        },
        {
          path: 'alerts',
          name: 'alerts',
          component: AlertList
        },
        {
          path: 'grades',
          name: 'grades',
          component: StudentList
        },
        {
          path: 'calendar',
          name: 'calendar',
          component: CalendarList
        }
      ]
    }
  ],
});


router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ['/'];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem('user');

  if (authRequired && !store.getters.user.id) {
    return next('/');
  }

  next();
})


export default router
